import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createAssetOverviewEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackAssetOpen = (source: PosthogTrackingSource, entityTag: string) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ASSET_OPEN,
      properties: { source, entity: entityTag },
    });

  const trackAoDrawerOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.AO_DRAWER_OPEN,
      properties: { source },
    });

  const trackConnectionsTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.CONNECTIONS_TAB_SELECTED,
      properties: { source, type },
    });

  const trackAssetOverviewTabSelected = (
    source: PosthogTrackingSource,
    type: string
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ASSET_OVERVIEW_TAB_SELECTED,
      properties: { source, type },
    });

  const trackKgBrandDrawerOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.KG_BRAND_DRAWER_OPEN,
      properties: { source },
    });

  const trackKgGeographyDrawerOpen = (
    source: PosthogTrackingSource,
    type: 'country' | 'region'
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.KG_GEOGRAPHY_DRAWER_OPEN,
      properties: { source, type },
    });

  return {
    trackAssetOpen,
    trackAoDrawerOpen,
    trackConnectionsTabSelected,
    trackAssetOverviewTabSelected,
    trackKgBrandDrawerOpen,
    trackKgGeographyDrawerOpen,
  };
};
